module.exports = __webpack_public_path__ + "static/media/circle.6eaefe3c.png";